import { render } from "./FAQPart.vue?vue&type=template&id=315522ae"
import script from "./FAQPart.vue?vue&type=script&lang=js"
export * from "./FAQPart.vue?vue&type=script&lang=js"

import "./FAQPart.vue?vue&type=style&index=0&id=315522ae&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__